document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname === '/') {
    const birdContainer = document.createElement('div');
    birdContainer.id = 'bird-container';
    document.body.appendChild(birdContainer);

    let isBird1Next = true; // Toggle to alternate between bird1 and bird2

    function createBird() {
      const bird = document.createElement('div');
      const minHeight = 10; // Minimum height from the top of the viewport
      const maxHeight = window.innerHeight / 2; // Up to half of the viewport height

      // Alternate between bird1 and bird2
      if (isBird1Next) {
        bird.classList.add('bird', 'bird1');
      } else {
        bird.classList.add('bird', 'bird2');
      }

      // Toggle for the next bird
      isBird1Next = !isBird1Next;

      bird.style.top = minHeight + Math.random() * (maxHeight - minHeight) + 'px';
      bird.style.left = '-200px'; // Start off-screen to the left
      birdContainer.appendChild(bird);

      // Remove the bird after it completes its 2-second animation
      setTimeout(() => {
        if (birdContainer.contains(bird)) {
          birdContainer.removeChild(bird);
        }
      }, 6000); // Remove after 2 seconds
    }

    // Create the first bird immediately and then alternate every 10 seconds
    createBird();
    setInterval(createBird, 50000); // Create a new bird every 10 seconds
  }
});
